import React, { useEffect, useState } from "react";
// import Header from "../Layouts/Header.jsx";
import { DateTime } from "luxon";
import Single from "./Single.jsx";
import Jodi from "./Jodi.jsx";
import Stake from "./Stake";
import HeaderSection from "./HeaderSection.jsx";
import DoublePatti from "./DoublePatti.jsx";
import TriplePatti from "./TriplePatti.jsx";
import SinglePatti from "./SinglePatti.jsx";
import { Tabs, Tab } from "@heroui/react";
import { useSessionTimeout } from "../../hooks/useSessionTimeout.js";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { getUserIP } from "../../helpers/getIP.js";
import { Modal, ModalContent, ModalBody, useDisclosure } from "@heroui/react";
import { LoserIcon, WinnerIcon } from "../../components/HeaderSidebarIcons.jsx";

import { Card, CardBody, Button } from "@heroui/react";
import { Spinner } from "@heroui/react";

import { v4 as uuidv4 } from "uuid";
// import HeaderSection from "./HeaderSection.jsx";
import { jwtDecode } from "jwt-decode";

const MAX_SELECTION_VALUE = {
  single: 10,
  jodi: 100,
  singlePatti: 120,
  doublePatti: 90,
  tripplePatti: 10,
};

let DIGITS_MAP = {
  single_open: [...Array(10).keys()].map(String),
  single_close: [...Array(10).keys()].map(String),
  singlePatti_open: [
    "127",
    "136",
    "145",
    "190",
    "235",
    "280",
    "370",
    "389",
    "460",
    "479",
    "569",
    "578",
    "128",
    "137",
    "146",
    "236",
    "245",
    "290",
    "380",
    "470",
    "489",
    "560",
    "579",
    "678",
    "129",
    "138",
    "147",
    "156",
    "237",
    "246",
    "345",
    "390",
    "480",
    "570",
    "589",
    "679",
    "120",
    "139",
    "148",
    "157",
    "238",
    "247",
    "256",
    "346",
    "490",
    "580",
    "670",
    "689",
    "130",
    "149",
    "158",
    "167",
    "239",
    "248",
    "257",
    "347",
    "356",
    "590",
    "680",
    "789",
    "140",
    "159",
    "168",
    "230",
    "249",
    "258",
    "267",
    "348",
    "357",
    "456",
    "690",
    "780",
    "123",
    "150",
    "169",
    "178",
    "240",
    "259",
    "268",
    "349",
    "358",
    "367",
    "457",
    "790",
    "124",
    "160",
    "179",
    "250",
    "269",
    "278",
    "340",
    "359",
    "368",
    "458",
    "467",
    "890",
    "125",
    "134",
    "170",
    "189",
    "260",
    "279",
    "350",
    "369",
    "378",
    "459",
    "468",
    "567",
    "126",
    "135",
    "180",
    "234",
    "270",
    "289",
    "360",
    "379",
    "450",
    "469",
    "478",
    "568",
  ],
  singlePatti_close: [
    "127",
    "136",
    "145",
    "190",
    "235",
    "280",
    "370",
    "389",
    "460",
    "479",
    "569",
    "578",
    "128",
    "137",
    "146",
    "236",
    "245",
    "290",
    "380",
    "470",
    "489",
    "560",
    "579",
    "678",
    "129",
    "138",
    "147",
    "156",
    "237",
    "246",
    "345",
    "390",
    "480",
    "570",
    "589",
    "679",
    "120",
    "139",
    "148",
    "157",
    "238",
    "247",
    "256",
    "346",
    "490",
    "580",
    "670",
    "689",
    "130",
    "149",
    "158",
    "167",
    "239",
    "248",
    "257",
    "347",
    "356",
    "590",
    "680",
    "789",
    "140",
    "159",
    "168",
    "230",
    "249",
    "258",
    "267",
    "348",
    "357",
    "456",
    "690",
    "780",
    "123",
    "150",
    "169",
    "178",
    "240",
    "259",
    "268",
    "349",
    "358",
    "367",
    "457",
    "790",
    "124",
    "160",
    "179",
    "250",
    "269",
    "278",
    "340",
    "359",
    "368",
    "458",
    "467",
    "890",
    "125",
    "134",
    "170",
    "189",
    "260",
    "279",
    "350",
    "369",
    "378",
    "459",
    "468",
    "567",
    "126",
    "135",
    "180",
    "234",
    "270",
    "289",
    "360",
    "379",
    "450",
    "469",
    "478",
    "568",
  ],

  doublePatti_open: [
    "118",
    "226",
    "244",
    "299",
    "334",
    "488",
    "550",
    "668",
    "677",
    "100",
    "119",
    "155",
    "227",
    "335",
    "344",
    "399",
    "588",
    "669",
    "110",
    "200",
    "228",
    "255",
    "336",
    "499",
    "660",
    "688",
    "778",
    "166",
    "229",
    "300",
    "337",
    "355",
    "445",
    "599",
    "779",
    "788",
    "112",
    "220",
    "266",
    "338",
    "400",
    "446",
    "455",
    "699",
    "770",
    "113",
    "122",
    "177",
    "339",
    "366",
    "447",
    "500",
    "799",
    "889",
    "114",
    "277",
    "330",
    "448",
    "466",
    "556",
    "600",
    "880",
    "899",
    "115",
    "133",
    "188",
    "223",
    "377",
    "449",
    "557",
    "566",
    "700",
    "116",
    "224",
    "233",
    "288",
    "440",
    "477",
    "558",
    "800",
    "990",
    "117",
    "144",
    "199",
    "225",
    "388",
    "559",
    "577",
    "667",
    "900",
  ],
  doublePatti_close: [
    "118",
    "226",
    "244",
    "299",
    "334",
    "488",
    "550",
    "668",
    "677",
    "100",
    "119",
    "155",
    "227",
    "335",
    "344",
    "399",
    "588",
    "669",
    "110",
    "200",
    "228",
    "255",
    "336",
    "499",
    "660",
    "688",
    "778",
    "166",
    "229",
    "300",
    "337",
    "355",
    "445",
    "599",
    "779",
    "788",
    "112",
    "220",
    "266",
    "338",
    "400",
    "446",
    "455",
    "699",
    "770",
    "113",
    "122",
    "177",
    "339",
    "366",
    "447",
    "500",
    "799",
    "889",
    "114",
    "277",
    "330",
    "448",
    "466",
    "556",
    "600",
    "880",
    "899",
    "115",
    "133",
    "188",
    "223",
    "377",
    "449",
    "557",
    "566",
    "700",
    "116",
    "224",
    "233",
    "288",
    "440",
    "477",
    "558",
    "800",
    "990",
    "117",
    "144",
    "199",
    "225",
    "388",
    "559",
    "577",
    "667",
    "900",
  ],
  tripplePatti_open: [
    "000",
    "111",
    "222",
    "333",
    "444",
    "555",
    "666",
    "777",
    "888",
    "999",
  ],
  tripplePatti_close: [
    "000",
    "111",
    "222",
    "333",
    "444",
    "555",
    "666",
    "777",
    "888",
    "999",
  ],

  jodi_open: Array.from({ length: 100 }, (_, i) =>
    i.toString().padStart(2, "0")
  ),
  jodi_close: Array.from({ length: 100 }, (_, i) =>
    i.toString().padStart(2, "0")
  ),
};

const GameDetailPage = () => {
  const [selectedTab, setSelectedTab] = useState("photos");
  let rawBetType = localStorage.getItem("betType");
  let betTypeIn =
    rawBetType === null || rawBetType === "null" ? "single" : rawBetType;
  const [betType, setBetType] = useState(betTypeIn);
  const [betTime, setBetTime] = useState("open");
  const [selectedDigits, setSelectedDigits] = useState([]);
  const [stakeInput, setStakeInput] = useState(0);
  const [betHistory, setBetHistory] = useState([]);
  const [digitOptions, setDigitOptions] = useState(DIGITS_MAP["single_open"]);
  const [randomCount, setRandomCount] = useState("");
  const [rateMap, setRateMap] = useState({});
  const [minMaxMap, setMinMaxMap] = useState({});
  const [betTypes, setBetTypes] = useState([]);
  const [selectedType, setSelectedType] = useState("");
  const [selectedRate, setSelectedRate] = useState(null);
  const [selectedMinMax, setSelectedMinMax] = useState({});
  const [marketName, setMarketName] = useState("");
  const [markets, setMarkets] = useState([]);
  const [draw_date, setDrawDate] = useState("");
  const [openTime, setOpenTime] = useState("");
  const [closeTime, setCloseTime] = useState("");
  const [isOpenSuspend, setIsOpenSuspend] = useState(0);
  const [isCloseSuspend, setIsCloseSuspend] = useState(0);
  const [selectedMarketKey, setSelectedMarketKey] = useState("");
  const [customDigits, setCustomDigits] = useState("");
  const [betsLog, setBetsLog] = useState([]);
  const [selectedStake, setSelectedStake] = useState(0);
  // const { balance, updateBalance, updateExposure } = useBalance();
  const [guruSelected, setGuruSelected] = useState([]);
  const [loading, setLoading] = useState(true);
  const [digitStakes, setDigitStakes] = useState({});
  const [lastSelectedDigit, setLastSelectedDigit] = useState("");
  const { isOpen, onOpen, onOpenChange } = useDisclosure();
  const [modalMessage, setModalMessage] = useState("");
  const [matchData, setMatchData] = useState([]);
  const openModalWithMessage = (message) => {
    setModalMessage(message);
    onOpen();
  };
  const [successToast, setSuccessToast] = useState(null);
  const [toastVisible, setToastVisible] = useState(false);
  const [validMatch, setValidMatch] = useState(false);
  const [timedOut, setTimedOut] = useState(false);
  const { matchId } = useParams();
  const { operatorId, userId } = useParams();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const tokenFromUrl = params.get("token");
  const { userName } = jwtDecode(tokenFromUrl);
  if (timedOut === false) {
    localStorage.setItem("opid", operatorId);
    sessionStorage.setItem("opid", operatorId);
    localStorage.setItem("uid", userId);
    sessionStorage.setItem("uid", userId);
    localStorage.setItem("uname", userName);
    sessionStorage.setItem("uname", userName);
    if (tokenFromUrl) {
      localStorage.setItem("authToken", tokenFromUrl);
      sessionStorage.setItem("authToken", tokenFromUrl);
    }
  }
  const token = tokenFromUrl;
  const handleTimeout = (type) => {
    localStorage.clear();
    sessionStorage.clear();
    setTimedOut(true);
  };
  useSessionTimeout(token, handleTimeout);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 2000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    localStorage.setItem("betType", betType);
  }, [betType]);

  const formatTimeTo12Hour = (time24) => {
    if (!time24) return "--";
    const [hour, minute] = time24.split(":");
    const date = new Date();
    date.setHours(hour);
    date.setMinutes(minute);
    return date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  // const formatDateToDDMMYYYY = (dateString) => {
  //   const date = new Date(dateString);
  //   return date
  //     .toLocaleDateString("en-GB", {
  //       timeZone: "Asia/Dubai",
  //       year: "numeric",
  //       month: "2-digit",
  //       day: "2-digit",
  //     })
  //     .replace(/\//g, "-");
  // };

  useEffect(() => {
    const getMatchDetails = async (e) => {
      let headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append(
        "Authorization",
        "Bearer " + localStorage.getItem("authToken")
      );
      // const urlencoded = {
      //   matchId: matchId,
      // };
      let requestOptions = {
        method: "GET",
        headers: headers,
        // body: JSON.stringify(urlencoded),
      };
      fetch(
        process.env.REACT_APP_API_HOST_OP +
          "/match/" +
          matchId +
          "/" +
          operatorId +
          "/" +
          userId,
        requestOptions
      )
        .then((response) => {
          if (response.status === 401) {
            console.log("Unauthorized access. Please log in again.");
          } else {
            return response.json();
          }
        })
        .then((result) => {
          setMatchData(result);
          if (result.data) {
            if (result.data.length > 0) setValidMatch(true);

            setIsOpenSuspend(result.data[0].open_suspend.data[0]);
            setIsCloseSuspend(result.data[0].close_suspend.data[0]);

            if (
              result.data[0].open_suspend.data[0] === 1 &&
              result.data[0].close_suspend.data[0] === 1
            ) {
              setSelectedMarketKey("open");
              setBetType("single");
              setBetTime("open");
            } else if (result.data[0].open_suspend.data[0] === 1) {
              setSelectedMarketKey("close");
              setBetType("single");
              setBetTime("close");
            } else if (result.data[0].close_suspend.data[0] === 1) {
              setSelectedMarketKey("open");
              setBetType("single");
              setBetTime("open");
            } else {
              setSelectedMarketKey("open");
              setBetType("single");
              setBetTime("open");
            }

            // setDrawDate(formatDateToDDMMYYYY(result.data[0].draw_date));
            setDrawDate(result.data[0].draw_date);
            setOpenTime(result.data[0].open_time || "");
            setCloseTime(result.data[0].close_time || "");

            const RATE_MAP = {};
            const BET_TYPES = [];
            const MIN_MAX_MAP = {};

            const ICON_MAP = {
              single: "/icons/single.svg",
              jodi: "/icons/jodi.svg",
              singlePatti: "/icons/single-patti.svg",
              doublePatti: "/icons/double-patti.svg",
              tripplePatti: "/icons/triple patti.svg",
            };

            result.data.forEach((item) => {
              const originalType = item.type_name.toLowerCase();
              let key = "";

              if (originalType === "single") key = "single";
              else if (originalType === "jodi") key = "jodi";
              else if (originalType === "single patti") key = "singlePatti";
              else if (originalType === "double patti") key = "doublePatti";
              else if (originalType === "triple patti") key = "tripplePatti";
              else return;

              MIN_MAX_MAP[key] = {
                min_stake: item.min_stake,
                max_stake: item.max_stake,
              };
              RATE_MAP[key] = item.rate;
              // BET_TYPES.push({ key, label: item.type_name.toUpperCase() });
              BET_TYPES.push({
                key,
                label: item.type_name.toUpperCase(),
                icon: ICON_MAP[key] || "", // fallback empty string if not found
              });
            });

            setMarketName(result.data[0].match_name);
            setRateMap(RATE_MAP);
            setBetTypes(BET_TYPES);
            setSelectedRate(RATE_MAP[betType] || null);
            setMinMaxMap(MIN_MAX_MAP);
            setSelectedMinMax(MIN_MAX_MAP[betType] || {});
            setSelectedType(betType);

            let markert_values = [
              {
                key: "open",
                label:
                  " OPEN (" +
                  formatTimeTo12Hour(result.data[0].open_time) +
                  ")",
              },
              {
                key: "close",
                label:
                  " CLOSE (" +
                  formatTimeTo12Hour(result.data[0].close_time) +
                  ")",
              },
            ];

            setMarkets(markert_values);
          }
        })
        .catch((err) => {
          // console.log("Error fetching events:", err);
        })
        .finally(() => {});
    };
    getMatchDetails();
  }, []);

  useEffect(() => {
    const getUserBets = async (e) => {
      let headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append(
        "Authorization",
        "Bearer " + localStorage.getItem("authToken")
      );
      // const urlencoded = {
      //   matchId: matchId,
      //   operator_id: operatorId,
      //   user_id: userId,
      // };
      let requestOptions = {
        method: "GET",
        headers: headers,
        // body: JSON.stringify(urlencoded),
      };
      fetch(
        process.env.REACT_APP_API_HOST_OP +
          "/bet/" +
          userId +
          "/" +
          matchId +
          "/" +
          operatorId,
        requestOptions
      )
        .then((response) => {
          if (response.status === 401) {
            console.log("Unauthorized access. Please log in again.");
          } else {
            return response.json();
          }
        })
        .then((result) => {
          if (result.data) {
            const groupedMap = new Map();
            const res = result.data;
            res.forEach((item) => {
              const key = `${item.id}-${item.time}`;
              if (!groupedMap.has(key)) {
                groupedMap.set(key, {
                  digitStakes: {},
                  rate: item.rate,
                  type: item.type_name,
                  time: item.time,
                });
              }
              groupedMap.get(key).digitStakes[item.digit] = parseFloat(
                item.stake
              );
            });
            const userBets = Array.from(groupedMap.values());
            setBetHistory(userBets);
          }
        })
        .catch((err) => {
          console.log("Error fetching events:", err);
        })
        .finally(() => {});
    };
    getUserBets();
  }, [matchId, operatorId, userId]);

  const getUserBetsLog = async (e) => {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append(
      "Authorization",
      "Bearer " + localStorage.getItem("authToken")
    );
    // const urlencoded = {
    //   matchId: matchId,
    //   user_id: userId,
    //   operator_id: operatorId,
    // };
    let requestOptions = {
      method: "GET",
      headers: headers,
      // body: JSON.stringify(urlencoded),
    };
    fetch(
      process.env.REACT_APP_API_HOST_OP +
        "/bet/digits/" +
        userId +
        "/" +
        matchId +
        "/" +
        operatorId,
      requestOptions
    )
      .then((response) => {
        if (response.status === 401) {
          console.log("Unauthorized access. Please log in again.");
        } else {
          return response.json();
        }
      })
      .then((result) => {
        if (result.data) {
          setBetsLog(result.data);
        }
      })
      .catch((err) => {
        console.log("Error fetching events:", err);
      })
      .finally(() => {});
  };

  useEffect(() => {
    getUserBetsLog();
  }, []);

  const handleDigitToggle = (digit) => {
    if (!selectedStake) {
      openModalWithMessage("Please select stake amount first");
      return;
    }
    setLastSelectedDigit(digit);
    setDigitStakes((prev) => ({
      ...prev,
      [digit]: (prev[digit] || 0) + selectedStake,
    }));
  };

  const checkOpenCloseBet = () => {
    const [day, month, year] = draw_date.split("-");
    const formattedDate = `${year}-${month}-${day}`;
    const now = new Date();
    if (betTime === "open") {
      const openDateTime = new Date(`${formattedDate}T${openTime}`);
      if (now >= openDateTime) {
        return {
          status: false,
          message: "Open Betting is closed for this match.",
        };
      } else {
        return true;
      }
    }
    if (betTime === "close") {
      const closeDateTime = new Date(`${formattedDate}T${closeTime}`);
      if (now > closeDateTime) {
        return { status: false, message: "Betting is closed for this match." };
      } else {
        return true;
      }
    }
  };

  const handleCustomInput = (e) => {
    let input = e.target.value;
    input = input.replace(/[^0-9,]/g, "");
    if (input.startsWith(",")) {
      input = input.slice(1);
    }
    input = input.replace(/,+/g, ",");
    setCustomDigits(input);
  };

  // function addMissingValues(sourceArray, compareArray) {
  //   compareArray.forEach((value) => {
  //     if (!sourceArray.includes(value)) {
  //       sourceArray.push(value);
  //     }
  //   });
  // }

  // const handleSubmit = async () => {
  //   // console.log(digitStakes);
  //   let customArray = [];
  //   let mergedArray = [];
  //   let customDigitsTo = "";
  //   if (customDigits.length > 0) {
  //     if (customDigits.endsWith(",")) {
  //       customDigitsTo = customDigits.slice(0, -1);
  //     } else {
  //       customDigitsTo = customDigits;
  //     }
  //     customArray = customDigitsTo.split(",").map((d) => d.trim());
  //     mergedArray = [...new Set([...selectedDigits, ...customArray])];
  //   } else {
  //     mergedArray = [...selectedDigits];
  //   }
  //   if (betType === "single") {
  //     const invalidNumbers = mergedArray.filter(
  //       (num) => Number(num) < 0 || Number(num) > 9 || isNaN(Number(num))
  //     );
  //     if (invalidNumbers.length > 0) {
  //       alert(`Please enter proper digit(s) between 0-9`);
  //       return;
  //     }
  //   }
  //   if (betType === "singlePatti" || betType === "doublePatti") {
  //     const invalidNumbers = mergedArray.filter(
  //       (num) => Number(num) < 100 || Number(num) > 999 || isNaN(Number(num))
  //     );
  //     if (invalidNumbers.length > 0) {
  //       alert(`Please enter proper digit(s) between 100-999`);
  //       return;
  //     }
  //   }
  //   if (betType === "tripplePatti") {
  //     const invalidNumbers = mergedArray.filter(
  //       (num) => !/^\d{3}$/.test(num) // must be exactly 3 digits (e.g. "000", "111", "999")
  //     );
  //     if (invalidNumbers.length > 0) {
  //       alert(`Please enter only 3-digit numbers for Triple Patti`);
  //       return;
  //     }
  //   }
  //   if (betType === "jodi") {
  //     const invalidNumbers = mergedArray.filter(
  //       (num) => !/^\d{2}$/.test(num) // must be exactly 2 digits (e.g. "00", "11", "99")
  //     );
  //     if (invalidNumbers.length > 0) {
  //       alert(`Please enter only 2-digit numbers for Jodi`);
  //       return;
  //     }
  //   }
  //   if (betTime === "open" && isOpenSuspend === 1) {
  //     alert("Open betting is suspended for this match.");
  //     return;
  //   }
  //   if (betTime === "close" && isCloseSuspend === 1) {
  //     alert("Close betting is suspended for this match.");
  //     return;
  //   }

  //   // let betOk = checkOpenCloseBet();
  //   // if (!betOk) {
  //   //   // alert("Unable to place Bet");
  //   // }
  //   let betOk = true;
  //   if (betOk === true) {
  //     // const totalStake = selectedDigits.reduce((sum, d) => sum + parseInt(d.stake || 0), 0);
  //     // const totalStake = digitStakes.reduce(
  //     //   (sum, digit) => sum + (digitStakes[digit] || 0),
  //     //   0
  //     // );
  //     const totalStake = Object.values(digitStakes).reduce((a, b) => a + b, 0);

  //     // alert(totalStake);
  //     // return;
  //     // const stake = parseInt(stakeInput);
  //     // if (
  //     //   mergedArray.length === 0 ||
  //     //   isNaN(stake) ||
  //     //   stake < minMaxMap[selectedType]?.min_stake ||
  //     //   stake > minMaxMap[selectedType]?.max_stake
  //     // ) {
  //     //   alert(
  //     //     "Select digit(s) and enter a valid stake (" +
  //     //       minMaxMap[selectedType]?.min_stake +
  //     //       " – " +
  //     //       minMaxMap[selectedType]?.max_stake +
  //     //       ")"
  //     //   );
  //     //   return;
  //     // }
  //     const newEntry = {
  //       digits: Object.keys(digitStakes), // ['1', '2', '3', '4']
  //       digitStakes: { ...digitStakes }, // full map of digit → stake
  //       rate: selectedRate,
  //       type: betType,
  //       time: betTime,
  //     };
  //     // let amount = mergedArray.length * stake;
  //     // if (amount > balance) {
  //     //   alert("Insufficient Fund, Unable to place bet!");
  //     //   return;
  //     // }
  //     setBetHistory((prev) => [...prev, newEntry]);
  //     updateBalance(totalStake);
  //     updateExposure(totalStake);
  //     // const categoryArray = DIGITS_MAP[betType + "_" + betTime];
  //     // addMissingValues(categoryArray, mergedArray);
  //     // setLoading(true);
  //     const updatedBetHistory = [...betHistory, newEntry];
  //     const results = calculateResults(updatedBetHistory);
  //     console.log(results);
  //     const userIP = await getUserIP();
  //     const TYPE_ID_MAP = {
  //       single: 1,
  //       singlePatti: 2,
  //       doublePatti: 3,
  //       tripplePatti: 4,
  //       jodi: 5,
  //     };
  //     const TIME_TYPE_MAP = {
  //       open: 0,
  //       close: 1,
  //     };
  //     let headers = new Headers();
  //     headers.append("Content-Type", "application/json");
  //     headers.append("Authorization", "Bearer " + localStorage.getItem("jwt"));
  //     const urlencoded = {
  //       matchId: matchId,
  //       digit: digitStakes,
  //       // stake: stake,
  //       // digitStakes:
  //       rate: selectedRate,
  //       type_name: betType,
  //       type_id: TYPE_ID_MAP[betType],
  //       time: betTime,
  //       is_closed_type: TIME_TYPE_MAP[betTime],
  //       user_id: userId,
  //       operator_id: operatorId,
  //       trans_type: "Bet",
  //       request_type: "Bet Request",
  //       debit_amount: totalStake,
  //       status_id: 1,
  //       ip: userIP,
  //       pp: results,
  //       amount: totalStake,
  //     };
  //     let requestOptions = {
  //       method: "POST",
  //       headers: headers,
  //       body: JSON.stringify(urlencoded),
  //     };
  //     fetch(process.env.REACT_APP_API_HOST_OP + "/placebet", requestOptions)
  //       .then((response) => {
  //         if (response.status === 401) {
  //           console.log("Unauthorized access. Please log in again.");
  //         } else {
  //           return response.json();
  //         }
  //       })
  //       .then((result) => {
  //         if (result.success) {
  //           setTimeout(() => {
  //             setLoading(false);
  //           }, 1000);
  //           getUserBetsLog();
  //         } else {
  //           console.error("Error saving bet:", result.message);
  //         }
  //       })
  //       .catch((err) => {
  //         console.error("Error saving bet:", err);
  //       });
  //     setSelectedDigits([]);
  //     setStakeInput(0);
  //     setDigitStakes({});
  //     setSelectedStake(0);
  //   }
  // };

  const handleSubmit = async () => {
    if (!selectedStake) {
      openModalWithMessage("Please select stake amount");
      return;
    }
    if (Object.keys(digitStakes).length <= 0) {
      openModalWithMessage("Please select digit(s)");
      return;
    }

    if (betTime === "open" && isOpenSuspend === 1) {
      openModalWithMessage("Open betting is suspended for this match.");
      return;
    }
    if (betTime === "close" && isCloseSuspend === 1) {
      openModalWithMessage("Close betting is suspended for this match.");
      return;
    }

    // let betOk = checkOpenCloseBet();
    // if (betOk.status === false) {
    //   openModalWithMessage(betOk.message);
    //   return;
    // }

    // if (betOk === true) {
    const totalStake = Object.values(digitStakes).reduce((a, b) => a + b, 0);
    const TYPE_ID_MAP = {
      single: 1,
      singlePatti: 2,
      doublePatti: 3,
      tripplePatti: 4,
      jodi: 5,
    };
    const TIME_TYPE_MAP = {
      open: 0,
      close: 1,
    };
    const request_id = uuidv4();
    const transaction_id = `txn-${uuidv4()}`;
    const userIP = await getUserIP();
    const newEntry = {
      digits: Object.keys(digitStakes),
      digitStakes: { ...digitStakes },
      rate: selectedRate,
      type: betType,
      time: betTime,
    };
    setLoading(true);
    setBetHistory((prev) => [...prev, newEntry]);
    const updatedBetHistory = [...betHistory, newEntry];
    const results = calculateResults(updatedBetHistory);

    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append(
      "Authorization",
      "Bearer " + localStorage.getItem("authToken")
    );
    const urlencoded = {
      requestId: request_id,
      transactionId: transaction_id,
      userId: userId,
      userName: userName,
      operatorId: operatorId,
      transType: "Bet",
      requestType: "Bet Request",
      debitAmount: totalStake,
      matchId: matchId,
      digit: digitStakes,
      rate: selectedRate,
      type_name: betType,
      type_id: TYPE_ID_MAP[betType],
      time: betTime,
      is_closed_type: TIME_TYPE_MAP[betTime],
      status_id: 1,
      ip: userIP,
      pp: results,
      token: tokenFromUrl || localStorage.getItem("authToken"),
    };
    let requestOptions = {
      method: "POST",
      headers: headers,
      body: JSON.stringify(urlencoded),
    };
    fetch(process.env.REACT_APP_API_HOST_OP + "/placebet", requestOptions)
      .then((response) => {
        if (response.status === 401) {
        } else {
          return response.json();
        }
      })
      .then((result) => {
        if (result.status === "RS_OK") {
          // Show success toast
          setSuccessToast("Successfully Placed Bet");

          setToastVisible(true); // fade in

          // Start fade-out after 2 seconds
          setTimeout(() => {
            setToastVisible(false);
          }, 2500);

          // Remove from DOM after fade-out completes (e.g., 500ms)
          setTimeout(() => {
            setSuccessToast(null);
          }, 2500);
          // openModalWithMessage("Successfully Placed Bet");
          setSelectedDigits([]);
          setStakeInput(0);
          setDigitStakes({});
          setSelectedStake(0);
          setLastSelectedDigit("");
          setTimeout(() => {
            setLoading(false);
          }, 1000);
          getUserBetsLog();
        } else {
          setBetHistory((prev) => prev.slice(0, -1));
          openModalWithMessage("Unable to Place Bet");
          setDigitStakes({});
          setSelectedStake(0);
          setLastSelectedDigit("");
          setTimeout(() => {
            setLoading(false);
          }, 1000);
          getUserBetsLog();
        }
      })
      .catch((err) => {});
    // }
  };

  const calculateResults = (history = betHistory) => {
    const digitStakeMap = {};
    let totalStake = 0;

    let getdigitOps = DIGITS_MAP[betType + "_" + betTime];
    getdigitOps.forEach((digit) => {
      digitStakeMap[digit] = 0;
    });

    history
      .filter((entry) => entry.type === betType && entry.time === betTime)
      .forEach(({ digitStakes }) => {
        for (const [digit, stake] of Object.entries(digitStakes)) {
          totalStake += parseInt(stake);
          digitStakeMap[digit] += parseInt(stake);
        }
      });

    const results = {};
    getdigitOps.forEach((digit) => {
      const stake = digitStakeMap[digit];
      results[digit] =
        stake > 0 ? stake * selectedRate - totalStake : -totalStake;
    });

    return results;
  };

  const results = calculateResults();
  const renderComponent = () => {
    switch (betType) {
      case "jodi":
        return (
          <Jodi
            customDigits={customDigits}
            setCustomDigits={setCustomDigits}
            handleCustomInput={handleCustomInput}
            results={results}
            stakeInput={stakeInput}
            setStakeInput={setStakeInput}
            selectedDigits={selectedDigits}
            setSelectedDigits={setSelectedDigits}
            randomCount={randomCount}
            setRandomCount={setRandomCount}
            handleDigitToggle={handleDigitToggle}
            minMaxMap={minMaxMap}
            selectedType={selectedType}
            MAX_SELECTION_VALUE={MAX_SELECTION_VALUE}
            betType={betType}
            betTime={betTime}
            DIGITS_MAP={DIGITS_MAP}
            digitOptions={digitOptions}
            handleSubmit={handleSubmit}
            selectedStake={selectedStake}
            digitStakes={digitStakes}
            setDigitStakes={setDigitStakes}
            lastSelectedDigit={lastSelectedDigit}
            setLastSelectedDigit={setLastSelectedDigit}
            canCloseBet={canCloseBet}
            matchData={matchData}
            canOpenBet={canOpenBet}
          />
        );
      case "tripplePatti":
        return (
          <TriplePatti
            customDigits={customDigits}
            setCustomDigits={setCustomDigits}
            handleCustomInput={handleCustomInput}
            results={results}
            stakeInput={stakeInput}
            setStakeInput={setStakeInput}
            selectedDigits={selectedDigits}
            setSelectedDigits={setSelectedDigits}
            randomCount={randomCount}
            setRandomCount={setRandomCount}
            handleDigitToggle={handleDigitToggle}
            minMaxMap={minMaxMap}
            selectedType={selectedType}
            MAX_SELECTION_VALUE={MAX_SELECTION_VALUE}
            betType={betType}
            betTime={betTime}
            DIGITS_MAP={DIGITS_MAP}
            digitOptions={digitOptions}
            handleSubmit={handleSubmit}
            selectedStake={selectedStake}
            digitStakes={digitStakes}
            setDigitStakes={setDigitStakes}
            lastSelectedDigit={lastSelectedDigit}
            setLastSelectedDigit={setLastSelectedDigit}
            canOpenBet={canOpenBet}
            canCloseBet={canCloseBet}
            matchData={matchData}
          />
        );
      case "doublePatti":
        return (
          <DoublePatti
            customDigits={customDigits}
            setCustomDigits={setCustomDigits}
            handleCustomInput={handleCustomInput}
            results={results}
            stakeInput={stakeInput}
            setStakeInput={setStakeInput}
            selectedDigits={selectedDigits}
            setSelectedDigits={setSelectedDigits}
            randomCount={randomCount}
            setRandomCount={setRandomCount}
            handleDigitToggle={handleDigitToggle}
            minMaxMap={minMaxMap}
            selectedType={selectedType}
            MAX_SELECTION_VALUE={MAX_SELECTION_VALUE}
            betType={betType}
            betTime={betTime}
            DIGITS_MAP={DIGITS_MAP}
            digitOptions={digitOptions}
            handleSubmit={handleSubmit}
            selectedStake={selectedStake}
            digitStakes={digitStakes}
            setDigitStakes={setDigitStakes}
            lastSelectedDigit={lastSelectedDigit}
            setLastSelectedDigit={setLastSelectedDigit}
            canOpenBet={canOpenBet}
            canCloseBet={canCloseBet}
            matchData={matchData}
          />
        );
      case "singlePatti":
        return (
          <SinglePatti
            customDigits={customDigits}
            setCustomDigits={setCustomDigits}
            handleCustomInput={handleCustomInput}
            results={results}
            stakeInput={stakeInput}
            setStakeInput={setStakeInput}
            selectedDigits={selectedDigits}
            setSelectedDigits={setSelectedDigits}
            randomCount={randomCount}
            setRandomCount={setRandomCount}
            handleDigitToggle={handleDigitToggle}
            minMaxMap={minMaxMap}
            selectedType={selectedType}
            MAX_SELECTION_VALUE={MAX_SELECTION_VALUE}
            betType={betType}
            betTime={betTime}
            DIGITS_MAP={DIGITS_MAP}
            digitOptions={digitOptions}
            handleSubmit={handleSubmit}
            selectedStake={selectedStake}
            digitStakes={digitStakes}
            setDigitStakes={setDigitStakes}
            lastSelectedDigit={lastSelectedDigit}
            setLastSelectedDigit={setLastSelectedDigit}
            canOpenBet={canOpenBet}
            canCloseBet={canCloseBet}
            matchData={matchData}
          />
        );
      case "single":
        return (
          <Single
            customDigits={customDigits}
            setCustomDigits={setCustomDigits}
            handleCustomInput={handleCustomInput}
            results={results}
            stakeInput={stakeInput}
            setStakeInput={setStakeInput}
            selectedDigits={selectedDigits}
            setSelectedDigits={setSelectedDigits}
            randomCount={randomCount}
            setRandomCount={setRandomCount}
            handleDigitToggle={handleDigitToggle}
            minMaxMap={minMaxMap}
            selectedType={selectedType}
            MAX_SELECTION_VALUE={MAX_SELECTION_VALUE}
            betType={betType}
            betTime={betTime}
            DIGITS_MAP={DIGITS_MAP}
            digitOptions={digitOptions}
            handleSubmit={handleSubmit}
            setGuruSelected={setGuruSelected}
            selectedStake={selectedStake}
            digitStakes={digitStakes}
            setDigitStakes={setDigitStakes}
            lastSelectedDigit={lastSelectedDigit}
            setLastSelectedDigit={setLastSelectedDigit}
            canOpenBet={canOpenBet}
            canCloseBet={canCloseBet}
            matchData={matchData}
          />
        );
      default:
        return null;
    }
  };
  const formatDateTime = (isoDate) => {
    const date = new Date(isoDate);
    return date.toLocaleString("en-GB", {
      day: "2-digit",
      month: "long",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };
  const getSelection = (selection) => {
    switch (selection) {
      case 1:
        return "Single";
      case 2:
        return "Single Patti";
      case 3:
        return "Double Patti";
      case 4:
        return "Triple Patti";
      case 5:
        return "Jodi";
      default:
        return "Invalid selection";
    }
  };
  if (loading) {
    return (
      <div className="h-screen">
        <div className="flex items-center justify-center min-h-screen">
          <Spinner size="lg" variant="spinner" color="warning" />
        </div>
      </div>
    );
  }
  const marketOpenLabel = markets[0]?.label;
  const marketLabelClose = markets[1]?.label;
  // function isBettingClosed(marketOpenLabel,marketLabelClose) {
  //   const timeOpenMatch = marketOpenLabel.match(/\(([^)]+)\)/);
  //   const timeCloseMatch = marketLabelClose.match(/\(([^)]+)\)/);
  //   if (!timeOpenMatch) return false;
  //   if (!timeCloseMatch) return false;

  //   const openTimeISTString = DateTime.fromFormat(
  //     timeOpenMatch[1],
  //     "hh:mm a"
  //   ).toFormat("HH:mm");
  //    const closeTimeISTString = DateTime.fromFormat(
  //     timeCloseMatch[1],
  //     "hh:mm a"
  //   ).toFormat("HH:mm");
  //   const todayDateIST = DateTime.now()
  //     .setZone("Asia/Kolkata")
  //     .toFormat("yyyy-MM-dd");

  //   const matchOpenIST = DateTime.fromISO(`${todayDateIST}T${openTimeISTString}`, {
  //     zone: "Asia/Kolkata",
  //   });
  //    const matchCloseIST = DateTime.fromISO(`${todayDateIST}T${closeTimeISTString}`, {
  //     zone: "Asia/Kolkata",
  //   });

  //   const nowLocal = DateTime.now();

  //    return {
  //   openClosed: nowLocal >= matchOpenIST,
  //   closeClosed: nowLocal >= matchCloseIST
  // };
  // }
  // const canOpenBet = !isBettingClosed(markets?.[0]?.label || "");
  // const canCloseBet = !isBettingClosed(markets?.[1]?.label || "");

  // function getBettingStatus(marketOpenLabel = "", marketLabelClose = "") {
  //   // Make sure both labels are strings
  //   if (
  //     typeof marketOpenLabel !== "string" ||
  //     typeof marketLabelClose !== "string"
  //   ) {
  //     return { openClosed: false, closeClosed: false };
  //   }

  //   const timeOpenMatch = marketOpenLabel.match(/\(([^)]+)\)/);
  //   const timeCloseMatch = marketLabelClose.match(/\(([^)]+)\)/);
  //   console.log(timeCloseMatch,"timeCloseMatch");

  //   if (!timeOpenMatch || !timeCloseMatch) {
  //     return { openClosed: false, closeClosed: false };
  //   }

  //   const openTimeIST = DateTime.fromFormat(
  //     timeOpenMatch[1],
  //     "hh:mm a"
  //   ).setZone("Asia/Kolkata");
  //   const closeTimeIST = DateTime.fromFormat(
  //     timeCloseMatch[1],
  //     "hh:mm a"
  //   ).setZone("Asia/Kolkata");
  //   console.log(closeTimeIST,"closeTimeIST");

  //   const nowIST = DateTime.now().setZone("Asia/Kolkata");

  //   return {
  //     openClosed: nowIST >= openTimeIST,
  //     closeClosed: nowIST > closeTimeIST,
  //   };
  // }

  // // Use this after markets are loaded
  // const marketOpenLabel = markets?.[0]?.label ?? "";
  // const marketLabelClose = markets?.[1]?.label ?? "";
  // console.log(marketOpenLabel);
  // console.log(marketLabelClose);

  // const { openClosed, closeClosed } = getBettingStatus(
  //   marketOpenLabel,
  //   marketLabelClose
  // );

  // const canOpenBet = !openClosed;
  // const canCloseBet = !closeClosed;

  function getBettingStatus(marketOpenLabel = "", marketLabelClose = "") {
    if (
      typeof marketOpenLabel !== "string" ||
      typeof marketLabelClose !== "string"
    ) {
      return { openClosed: false, closeClosed: false };
    }

    const timeOpenMatch = marketOpenLabel.match(/\(([^)]+)\)/);
    const timeCloseMatch = marketLabelClose.match(/\(([^)]+)\)/);

    if (!timeOpenMatch || !timeCloseMatch) {
      return { openClosed: false, closeClosed: false };
    }

    // Parse and set time in IST zone
    const openTimeIST = DateTime.fromFormat(timeOpenMatch[1], "hh:mm a", {
      zone: "Asia/Kolkata",
    });
    const closeTimeIST = DateTime.fromFormat(timeCloseMatch[1], "hh:mm a", {
      zone: "Asia/Kolkata",
    });

    // Adjust times by subtracting 15 minutes
    const openCutoffTime = openTimeIST.minus({ minutes: 5 });
    const closeCutoffTime = closeTimeIST.minus({ minutes: 5 });

    const nowIST = DateTime.now().setZone("Asia/Kolkata");

    return {
      openClosed: nowIST >= openCutoffTime, // true means betting CLOSED for open
      closeClosed: nowIST >= closeCutoffTime, // true means betting CLOSED for close
    };
  }
  const { openClosed, closeClosed } = getBettingStatus(
    marketOpenLabel,
    marketLabelClose
  );

  const canOpenBet = !openClosed;
  const canCloseBet = !closeClosed;

  return (
    <div>
      {timedOut === false && (
        <div>
          {validMatch ? (
            <div className="  -mt-1 md:mt-7  sm:p-0 pt-0  w-full max-w-5xl mx-auto my-6">
              <div className="px-0 mx-auto max-w-screen-xl md:max-w-screen-2xl 2xl:max-w-screen-xl lg:py-0">
                <section className="md:py-0 py-4 bg-white rounded-b-lg shadow-lg border-gray-300 sm:border">
                  <div className=" w-full relative  ">
                    <Tabs
                      key="underlined"
                      variant="light"
                      className="w-full"
                      classNames={{
                        base: "w-full bg-matka_black p-0.5",
                        tabList: "gap-4 relative p-1",
                        tab: "h-9 px-3 py-1 text-center text-md text-white  data-[selected=true]:rounded",
                        cursor: "bg-m_text1",
                        panel: "mt-0",
                        tabContent: "text-white px-2 w-full h-full",
                      }}
                      selectedKey={selectedTab}
                      onSelectionChange={setSelectedTab}
                    >
                      <Tab key="photos" title={marketName || "SRIDEVII"}>
                        <div className="w-full !p-0 !m-0">
                          <HeaderSection
                            // formatDateToDDMMYYYY={formatDateToDDMMYYYY}
                            selectedMarketKey={selectedMarketKey}
                            setSelectedMarketKey={setSelectedMarketKey}
                            isOpenSuspend={isOpenSuspend}
                            isCloseSuspend={isCloseSuspend}
                            draw_date={draw_date}
                            markets={markets}
                            betTypes={betTypes}
                            betType={betType}
                            setBetType={setBetType}
                            setBetTime={setBetTime}
                            setSelectedDigits={setSelectedDigits}
                            setStakeInput={setStakeInput}
                            setBetHistory={setBetHistory}
                            setRandomCount={setRandomCount}
                            DIGITS_MAP={DIGITS_MAP}
                            rateMap={rateMap}
                            setDigitOptions={setDigitOptions}
                            selectedRate={selectedRate}
                            setSelectedRate={setSelectedRate}
                            selectedType={selectedType}
                            setSelectedType={setSelectedType}
                            minMaxMap={minMaxMap}
                            setMinMaxMap={setMinMaxMap}
                            selectedMinMax={selectedMinMax}
                            setSelectedMinMax={setSelectedMinMax}
                            setDigitStakes={setDigitStakes}
                            setSelectedStake={setSelectedStake}
                            setLastSelectedDigit={setLastSelectedDigit}
                            betTime={betTime}
                            betsLog={betsLog}
                            matchData={matchData}
                            canOpenBet={canOpenBet}
                            canCloseBet={canCloseBet}
                          />
                        </div>
                        <div className="w-full !p-0 m-0 mt-3">
                          <Stake
                            selectedStake={selectedStake}
                            setSelectedStake={setSelectedStake}
                            stakeInput={stakeInput}
                            setStakeInput={setStakeInput}
                            minMaxMap={minMaxMap}
                            selectedType={selectedType}
                            canOpenBet={canOpenBet}
                            canCloseBet={canCloseBet}
                            betTime={betTime}
                            matchData={matchData}
                          />
                        </div>

                        <div id="main-card1" className="mt-1">
                          {renderComponent()}
                        </div>
                      </Tab>
                      <Tab
                        key="music"
                        title="BETS"
                        color="primary"
                        className="data-[state=active]:text-primary"
                      >
                        <div className="container mx-auto px-4 py-3">
                          {/* <div className="text-center mb-6">
                      <h3 className="text-xl font-bold text-gray-800">
                        Bet History
                      </h3>
                    </div> */}
                          {betsLog.map((row, index) => (
                            <Card
                              className="shadow-xl border border-gray-400 mb-3"
                              radius="sm"
                            >
                              <CardBody className="p-4">
                                <div className="absolute left-0 top-0 bg-m_peach text-white text-center text-sm px-1.5 py-0.5 w-36 z-10 mb-2">
                                  {getSelection(row.match_map_id)}
                                </div>

                                <div className="text-sm font-semibold text-m_red mb-2 mt-4">
                                  {row.name}{" "}
                                  {row.is_closed_type.data[0] === 0
                                    ? "OPEN"
                                    : "CLOSE"}{" "}
                                  -{" "}
                                  <span className="text-xs px-1 italic">
                                    {formatDateTime(row.created_on)}
                                  </span>
                                </div>

                                <div className="grid grid-cols-3 gap-y-2 text-sm text-m_black">
                                  <div>
                                    <span className="text-sm text-m_black font-medium">
                                      Digit :{" "}
                                    </span>
                                    <span className="text-xs">{row.digit}</span>
                                  </div>
                                  <div class="flex justify-center items-center gap-1">
                                    <span class="font-medium">Stake :</span>
                                    <span class="text-xs">
                                      {" "}
                                      {parseFloat(row.stake).toFixed(2)}
                                    </span>
                                  </div>
                                  {row.status_id === 5 ? (
                                    <p className="text-gray-600 text-sm italic text-center">
                                      Bet Abandoned
                                    </p>
                                  ) : row.status_id === 4 ? (
                                    <p className="text-yellow-600 text-sm italic text-center">
                                      Bet Cancelled
                                    </p>
                                  ) : row.time === "open" ? (
                                    !row.open_result ||
                                    row.open_result === "" ? (
                                      <p className="text-red-500 text-sm italic text-center">
                                        Pending, Wait for Result
                                      </p>
                                    ) : row.win === 1 ? (
                                      <p className="flex items-center justify-center gap-1 text-green-600 text-sm italic text-center">
                                        Congratulations, you won! <WinnerIcon />
                                      </p>
                                    ) : row.win === 0 ? (
                                      <p className="text-red-500 text-sm italic flex items-center justify-center gap-1">
                                        Lose, Please try again. <LoserIcon />
                                      </p>
                                    ) : null
                                  ) : row.time === "close" ? (
                                    !row.close_result ||
                                    row.close_result === "" ? (
                                      <p className="text-red-500 text-sm italic text-center">
                                        Pending, Wait for Result
                                      </p>
                                    ) : row.win === 1 ? (
                                      <p className="flex items-center justify-center gap-1 text-green-600 text-sm italic text-center">
                                        Congratulations, you won! <WinnerIcon />
                                      </p>
                                    ) : row.win === 0 ? (
                                      <p className="text-red-500 text-sm italic flex items-center justify-center gap-1">
                                        Lose, Please try again.
                                        <LoserIcon />
                                      </p>
                                    ) : null
                                  ) : null}
                                  {/* <div>
                                    <span className="text-sm text-m_black font-medium">
                                      P & L :{" "}
                                    </span>
                                    <span className="text-xs">
                                      {row.stake * row.rate}
                                    </span>
                                  </div> */}
                                  {/* <div>
                              <span className="text-sm text-m_black font-medium">
                                Rate :{" "}
                              </span>
                              <span className="text-xs">{row.rate}</span>
                            </div> */}
                                </div>

                                {/* <p className="mt-1 text-sm text-red-500 flex justify-center gap-1 italic">
                            <p className="w-4 h-4 " />
                            <span className="py-1 text-red-500">
                              <LoserIcon />
                            </span>
                            Lose, Please try again.
                          </p> */}
                                {/* <p className="mt-1 text-sm text-m_green flex justify-center gap-1 italic">
                            <p className="w-4 h-4 " />
                           <span className="py-0.5 text-m_green"><WinnerIcon/></span> Win, Congratulations.   
                            
                          </p> */}
                              </CardBody>
                            </Card>
                          ))}
                        </div>
                      </Tab>
                    </Tabs>
                    <Button
                      onClick={() => window.history.back()}
                      className="absolute right-2 -top-1 bg-black flex text-white border-1 rounded-small text-xs mt-2"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill="currentColor"
                          d="M3.283 10.94a1.5 1.5 0 0 0 0 2.12l5.656 5.658a1.5 1.5 0 1 0 2.122-2.122L7.965 13.5H19.5a1.5 1.5 0 0 0 0-3H7.965l3.096-3.096a1.5 1.5 0 1 0-2.122-2.121z"
                        />
                      </svg>
                      <span>Back</span>
                    </Button>
                  </div>
                </section>
              </div>
              {successToast && (
                <Modal
                  isOpen={!!successToast}
                  onOpenChange={() => setSuccessToast(null)}
                  hideCloseButton="true"
                  classNames={{
                    backdrop: "bg-black/35",
                    wrapper:
                      "flex items-center justify-center min-h-screen pointer-events-none",
                  }}
                  className={`transition-opacity duration-500 pointer-events-auto ${
                    toastVisible ? "opacity-100" : "opacity-0"
                  }`}
                >
                  <ModalContent className="w-auto max-w-lg">
                    {(onClose) => (
                      <ModalBody
                        className={`transition-opacity duration-500 pointer-events-auto ${
                          toastVisible ? "opacity-100" : "opacity-0"
                        }`}
                      >
                        <div className="flex items-center justify-center min-h-[60px] p-4 gap-x-2">
                          <div className="flex-shrink-0">
                            <svg
                              fill="none"
                              height="24"
                              viewBox="0 0 24 24"
                              width="24"
                              xmlns="http://www.w3.org/2000/svg"
                              className="fill-current w-6 h-6 text-green-600"
                            >
                              <path d=" M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2Z M16.78 9.7L11.11 15.37C10.97 15.51 10.78 15.59 10.58 15.59C10.38 15.59 10.19 15.51 10.05 15.37L7.22 12.54 C6.93 12.25 6.93 11.77 7.22 11.48C7.51 11.19 7.99 11.19 8.28 11.48L10.58 13.78L15.72 8.64 C16.01 8.35 16.49 8.35 16.78 8.64C17.07 8.93 17.07 9.4 16.78 9.7Z "></path>
                            </svg>
                          </div>
                          <p className="text-center font-semibold text-m_black">
                            {successToast}
                          </p>
                        </div>
                      </ModalBody>
                    )}
                  </ModalContent>
                </Modal>
              )}

              <Modal
                isOpen={isOpen}
                onOpenChange={onOpenChange}
                classNames={{
                  backdrop: "bg-black/35",
                  wrapper:
                    "flex items-center justify-center min-h-screen sm:-mt-10 md:-mt-8",
                }}
              >
                <ModalContent>
                  {(onClose) => (
                    <>
                      {/* <ModalHeader className="flex flex-col gap-1">
                        {" "}
                        Message
                      </ModalHeader> */}
                      <ModalBody className="flex items-center justify-center min-h-[80px] p-0">
                        <p className="text-center font-semibold">
                          {modalMessage}
                        </p>
                      </ModalBody>
                    </>
                  )}
                </ModalContent>
              </Modal>
            </div>
          ) : (
            <div className="flex items-center justify-center h-96">
              <div className="text-center">
                <h2 className="text-xl font-semibold text-gray-600">
                  Invalid Match
                </h2>
              </div>
            </div>
          )}
        </div>
      )}
      {timedOut && (
        <div className="min-h-screen bg-admin_black flex flex-col items-center justify-center">
          <h1 className="text-white text-3xl font-semibold">
            Session TimeOut.
          </h1>
        </div>
      )}
    </div>
  );
};
export default GameDetailPage;
